import { Component, OnInit, Injectable, Input, Output, EventEmitter } from "@angular/core";
import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { BehaviorSubject } from "rxjs";

export class TreviewNode {
  type: any;
  children: TreviewNode[];
  nombre: string;
  id: string;
  tag: any;
}

@Injectable()
export class xsTreeviewData {
  dataChange = new BehaviorSubject<TreviewNode[]>([]);

  get data(): TreviewNode[] {
    return this.dataChange.value;
  }

  constructor() {
    //this.initialize();
  }

  initialize(treeNodes) {
    //console.log("treeNodes: ", treeNodes);
    // Parse the string to json object.
    const dataObject = JSON.parse(treeNodes);

    // Build the tree nodes from Json object. The result is a list of `TreviewNode` with nested
    //     file node as children.
    const data = this.buildTreeview(dataObject, 0);

    //console.log("Treeview: ", data);

    // Notify the change.
    this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TreviewNode`.
   */
  buildTreeview(obj: object, level: number): TreviewNode[] {
    return Object.keys(obj).reduce<TreviewNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TreviewNode();
      node.nombre = value.nombre;
      node.id = value.id;
      node.tag = value;
      //console.log("node.nombre", level, value, node.nombre);

      if (value.children != null) {
        if (typeof value.children === "object") {
          node.children = this.buildTreeview(value.children, level + 1);
        }
      }

      return accumulator.concat(node);
    }, []);
  }
}

@Component({
  selector: "app-treeview-widget",
  templateUrl: "./treeview-widget.component.html",
  styleUrls: ["./treeview-widget.component.css"],
  providers: [xsTreeviewData]
})
export class TreeviewWidgetComponent implements OnInit {
  @Input()
  parametro: any;
  @Output()
  nodoClick: EventEmitter<any> = new EventEmitter();

  nestedTreeControl: NestedTreeControl<TreviewNode>;
  nestedDataSource: MatTreeNestedDataSource<TreviewNode>;

  constructor(public database: xsTreeviewData) {
    this.nestedTreeControl = new NestedTreeControl<TreviewNode>(this._getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();
  }

  hasNestedChild = (_: number, nodeData: TreviewNode) => !nodeData.type;
  private _getChildren = (node: TreviewNode) => node.children;

  ngOnInit() {
    this.database.initialize(JSON.stringify(this.parametro.nodos));
    this.database.dataChange.subscribe(data => {
      this.nestedDataSource.data = data;
      //console.log("Asignando Data", data);

      //Es necesario asignar esta propiedad para poder usar luego expandAll
      this.nestedTreeControl.dataNodes = data;
    });

    // this.nestedTreeControl.dataNodes = [];
    this.nestedTreeControl.expandAll();
  }

  onClickTreeNodo(nodo) {
    //console.log("treeview:", nodo);
    this.nodoClick.emit(nodo);
  }
}
